import React, { MemoExoticComponent, memo } from 'react';
import ModalWrapper from './modal-wrapper';
import { KBEntity, Section, Tag } from '../../admin-knowledge-base.type';

import { useModalForm } from '../../hooks/use-modal-form';
import { ArticleForm } from '../forms/article-form';
import { CategoryForm } from '../forms/category-form';
import { SectionForm } from '../forms/section-form';
import { TagForm } from '../forms/tag-form';
import { Types } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';

type CommonModalProps<Entity extends KBEntity> = ReturnType<typeof useModalForm<Entity>> & {
    tags?: Tag[];
    sections?: Section[];
};

const forms: Record<Types, MemoExoticComponent<any>> = {
    tag: TagForm,
    article: ArticleForm,
    category: CategoryForm,
    section: SectionForm,
};

const genericMemo: <T>(component: T) => T = memo;

const CommonModal = genericMemo(
    <Entity extends KBEntity>({
        id,
        type,
        mode,
        form,
        onSubmit,
        hideForm: close,
        sections,
        tags,
    }: CommonModalProps<Entity>) => {
        const Form = forms[type];
        return (
            <ModalWrapper
                mode={mode}
                close={close}
                type={type}
            >
                <Form {...{ onSubmit, close, form, id, sections, tags }} />
            </ModalWrapper>
        );
    }
);

export default CommonModal;
